import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeTr from '@angular/common/locales/tr';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

// ✅ LOCALE-FIX: Register Turkish locale for DatePipe
// Fixes Bug 4.1: NG0701 Missing locale data error
registerLocaleData(localeTr, 'tr');

// ✅ AE-6: Initialize Sentry BEFORE Angular bootstraps (Lightweight Config)
// Minimal configuration to avoid resource loading issues in development
if (environment.sentry?.enabled && environment.sentry?.dsn) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    release: 'farturk-angular@5.0.0', // Version from package.json
    // Minimal integrations - avoid heavy dependencies in dev mode
    integrations: environment.production ? [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ] : [],
    tracesSampleRate: environment.production ? environment.sentry.tracesSampleRate : 0,
    replaysSessionSampleRate: 0, // Disable session replay to save resources
    replaysOnErrorSampleRate: environment.production ? environment.sentry.replaysOnErrorSampleRate : 0,
    sendDefaultPii: false, // Don't send PII for privacy/GDPR compliance
    beforeSend(event) {
      // Filter sensitive data
      if (event.request?.headers) {
        delete event.request.headers['Authorization'];
        delete event.request.headers['Cookie'];
      }
      return event;
    }
  });

  console.log('✅ Sentry initialized (release: 5.0.0)');
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
